module.exports = __webpack_public_path__ + "static/media/face-female-1.8f8f5ebd.jpg";